import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { IS_LOCAL_ENV, PLAYER_HOSTNAME } from "./config/integrations";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

const isPlayerDomain = !IS_LOCAL_ENV && Boolean(PLAYER_HOSTNAME) && window.location.hostname === PLAYER_HOSTNAME;

if ("serviceWorker" in navigator && (isPlayerDomain || window.location.pathname.startsWith("/player"))) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/player-sw.js").catch(() => undefined);
  });
}
